import { render, staticRenderFns } from "./NewMembers.vue?vue&type=template&id=e997ebf8&scoped=true"
import script from "./NewMembers.vue?vue&type=script&lang=js"
export * from "./NewMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e997ebf8",
  null
  
)

export default component.exports